import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import AppContext from '../context/AppContext';
import Alert from './Alert';

const NotificationsContainer = styled.div`
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: ${({ theme }) => theme.zIndex.notifications};
  width: 350px;
  max-width: calc(100vw - 2rem);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const NotificationItem = styled.div`
  animation: slideIn 0.3s ease-out;
  
  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

/**
 * NotificationManager component for displaying system notifications
 * Uses the global AppContext to manage notifications
 */
const NotificationManager = () => {
  const { state, dispatch } = useContext(AppContext);
  const { notifications } = state;

  // Auto-dismiss notifications after a timeout
  useEffect(() => {
    if (notifications.length > 0) {
      const timers = notifications.map(notification => {
        if (notification.autoClose !== false) {
          const duration = notification.duration || 5000; // Default 5 seconds
          return setTimeout(() => {
            dispatch({
              type: 'HIDE_NOTIFICATION',
              payload: notification.id
            });
          }, duration);
        }
        return null;
      });

      // Clean up timers
      return () => {
        timers.forEach(timer => {
          if (timer) clearTimeout(timer);
        });
      };
    }
  }, [notifications, dispatch]);

  // Handle notification dismissal
  const handleDismiss = (id) => {
    dispatch({
      type: 'HIDE_NOTIFICATION',
      payload: id
    });
  };

  if (notifications.length === 0) {
    return null;
  }

  return (
    <NotificationsContainer>
      {notifications.map(notification => (
        <NotificationItem key={notification.id}>
          <Alert
            type={notification.type}
            message={notification.message}
            dismissible
            onClose={() => handleDismiss(notification.id)}
          />
        </NotificationItem>
      ))}
    </NotificationsContainer>
  );
};

export default NotificationManager;
